import { render } from "./NavigationTemplate.vue?vue&type=template&id=2c011e34"
import script from "./NavigationTemplate.vue?vue&type=script&lang=js"
export * from "./NavigationTemplate.vue?vue&type=script&lang=js"

import "./NavigationTemplate.vue?vue&type=style&index=0&id=2c011e34&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__